<template>
  <div class="w-lg-600px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto">
    <div class="text-center mb-10">
      <h1 class="text-dark mb-3">{{ $t("Désabonnement notifications ticket") }}</h1>
    </div>

    <div v-if="state.loading" class="text-center text-gray-700">
      {{ $t("Traitement en cours...") }}
    </div>

    <div v-else-if="state.ok" class="text-center">
      <div class="text-success fw-bold fs-4 mb-4">{{ $t("Désabonnement confirmé") }}</div>
      <p class="text-gray-700 mb-6">
        {{ $t("Vous ne recevrez plus les e-mails de notification ticket StillOnline.") }}
      </p>
      <p v-if="state.email" class="text-gray-600 mb-6">
        {{ state.email }}
      </p>
    </div>

    <div v-else class="text-center">
      <div class="text-danger fw-bold fs-4 mb-4">{{ $t("Lien invalide ou expiré") }}</div>
      <p class="text-gray-700 mb-6">
        {{ $t("Impossible de traiter votre demande de désabonnement.") }}
      </p>
    </div>

    <div class="d-flex flex-wrap justify-content-center pb-lg-0">
      <router-link to="/sign-in" class="btn btn-lg btn-light-primary fw-bolder">
        {{ $t("Retour à la page de connexion") }}
      </router-link>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive } from "vue";
import { useRoute } from "vue-router";
import axios from "axios";

export default defineComponent({
  name: "notif-unsubscribe",
  setup() {
    const route = useRoute();
    const state = reactive({
      loading: true,
      ok: false,
      email: "",
    });

    onMounted(async () => {
      const token = String(route.params.token || "");
      if (!token) {
        state.loading = false;
        return;
      }

      try {
        const baseUrl = process.env.VUE_APP_BACK_URL || "";
        const response = await axios.get(
          `${baseUrl}/unsubscribeNotifTicket/${encodeURIComponent(token)}`,
          { withCredentials: true }
        );
        const result = response.data?.results || response.data;
        state.ok = !!result?.ok;
        state.email = result?.con_mail || "";
      } catch {
        state.ok = false;
      } finally {
        state.loading = false;
      }
    });

    return { state };
  },
});
</script>
